
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _arrayWithHoles from './arrayWithHoles.js';
import _iterableToArrayLimit from './iterableToArrayLimit.js';
import _unsupportedIterableToArray from './unsupportedIterableToArray.js';
import _nonIterableRest from './nonIterableRest.js';

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

export { _slicedToArray as default };
//# sourceMappingURL=slicedToArray.js.map
